import * as angular from 'angular';
import {ILogService} from 'angular';
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {AgentInventoryRequestsService} from "./agent-inventory-requests.service";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class AgentInventoryService {

  constructor(private agentInventoryRequestsService: AgentInventoryRequestsService, private bringozToastService: BringozToastService,
              private bringozLoaderService: BringozLoaderService, private $log: ILogService, private $q) {
  }

  createUnloadTransaction(transaction: any) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.agentInventoryRequestsService.createUnloadTransaction(transaction)
      .then((createdDepot) => {
        const message = {
          body: 'Transaction created successfully'
        };
        this.bringozToastService.success(message);

        deferred.resolve(createdDepot);
      })
      .catch((error) => {
        this.$log.error(error);
        const message = {
          body: 'Failed to create transaction',
          details: 'SOMETHING_WENT_WRONG'
        };
        this.bringozToastService.error(message);

        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  createLoadTransaction(transaction: any) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.agentInventoryRequestsService.createLoadTransaction(transaction)
      .then((createdDepot) => {
        const message = {
          body: 'Transaction created successfully'
        };
        this.bringozToastService.success(message);

        deferred.resolve(createdDepot);
      })
      .catch((error) => {
        this.$log.error(error);
        const message = {
          body: 'Failed to create transaction',
          details: 'SOMETHING_WENT_WRONG'
        };
        this.bringozToastService.error(message);

        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }


}

angular
  .module('bringoz.admin.agent-inventory')
  .service('agentInventoryService', AgentInventoryService);
